define(['jquery', 'common', 'booking_rules', 'responsive_common','dirrty'], function ($, ERVCommon, ERVBookingRules, ERVResponsiveCommon) {
	var BookingWidget = function () {
		var self = this;
		self.bookingRules = new ERVBookingRules();
		self.$ervBody = $('#erv-body');
		self.$bookingWidget = self.$ervBody.find('#booking-widget');
		self.$bookingWidgetButton = self.$ervBody.find('#booking-widget-button');
		self.$ageTemplate = self.$ervBody.find('#age-template');
		self.$personPriceTemplate = self.$ervBody.find('#personprice-template');
		self.$countryTemplate = self.$ervBody.find('#country-template');
		self.$categoryForms = self.$bookingWidget.find('.category-forms');
		self.$NordicCancellationTotalInput = self.$bookingWidget.find('#AllForOneTotalDisplay');
		self.$fileUploadNameInput = self.$ervBody.find('[name="UploadedFileName"]');

		self.common = new ERVCommon();
		self.responsiveCommon = new ERVResponsiveCommon();
		self.useWebComponents = !!self.$bookingWidget.data('usewebcomponents');

        var updatePriceAmountPerPerson = function (totalSum) {
			var totalSumAsInt = parseInt(totalSum);
			var $individualInputs = self.$bookingWidget.find('[data-js="price-per-person"] input');

			if (totalSumAsInt >= 0 && $individualInputs.length > 0) {
				var indvidualSum = Math.floor(totalSum / $individualInputs.length),
					indvidualRest = (totalSum / $individualInputs.length) % 1, rest = 0;

				$individualInputs.each(function () {
					var $input = $(this);
					$input.val(indvidualSum);
					$input.removeClass('input-validation-error');
					$input.removeClass('input-validation-valid');
					rest += indvidualRest;
				});

				// add the rest
				rest = Math.round(rest);
				if (rest > 0) {
					var $firstInput = $individualInputs.first();
					$firstInput.val(parseInt($firstInput.val()) + rest);
				}
			}
		}

		var updateTotalPriceAmountPerPerson = function () {
			var $individualInputs = self.$bookingWidget.find('[data-js="price-per-person"] input');

			var totalSum = 0;

			$individualInputs.each(function () {
				var val = parseInt($(this).val());
				if (val >= 0) {
					totalSum += val;
				}
			});

			self.$NordicCancellationTotalInput.val(Math.ceil(totalSum));
		}

		var updateAmountOfPeoplePerson = function ($trigger, addPerson, selector, templateSelector, $template, containerSelector) {
			var $categoryForm = (typeof (containerSelector) === 'undefined' ? $trigger.parents('.insurance-fields') : $trigger.parents(containerSelector)),
				$amountOfPeople = $categoryForm.find('[data-peoplecount]'),
				$inputPersonCount = $categoryForm.find('[data-js=person-count]'),
				$valueContainer = $categoryForm.find(templateSelector),
				currentCount = Number($amountOfPeople.data('peoplecount'));

			if (addPerson) {
				if (self.bookingRules.hasReachedPeopleLimit($categoryForm, currentCount)) {
					return false;
				}

				self.addPeopleFields($valueContainer, $template, selector, currentCount);

				currentCount++;
			} else if (currentCount - 1 > 0){
				$valueContainer.find(selector).last().remove();
				currentCount--;
			}

			$amountOfPeople.data('peoplecount', currentCount);
			$inputPersonCount.val(currentCount);
			$inputPersonCount.trigger('change');
			$amountOfPeople.text(currentCount);

			self.bookingRules.travelingPeopleNotHigherThanTotalPeople($trigger);

			if (self.bookingRules.isNisCancellation($categoryForm)) {
				if ($categoryForm.find('#NisCancellationAllForOne').prop('checked'))
				{
					updatePriceAmountPerPerson(self.$NordicCancellationTotalInput.val());
				}
            }
		};

		self.addPeopleFields = function ($valueContainer, $template, selector, currentCount) {
			if ($valueContainer.find(selector).length <= 0) {
				return;
			}

			var html = $template.html().replace(/%%index%%/g, currentCount);
			html = html.replace(/%%indexLabel%%/g, currentCount + 1);

			var additionalPrefix = self.$bookingWidget.find('#SelectedProductCategoryTag').val();
			if (additionalPrefix) {
				html = html.replace(/%%prefix%%/g, additionalPrefix + "_");
			} else {
				html = html.replace(/%%prefix%%/g, "");
			}

			var $html = $(html);

			$html.insertAfter($valueContainer.find(selector).last());
			var $input = $html.find('input');

			if ($input.attr('name').indexOf('Ages') > -1) {
				$input.rules('add',
				{
					required: true,
					regex: '[0-9]*'
				});
			}

			if ($input.attr('name').indexOf('PersonPrices') > -1) {
				$input.rules('add',
				{
					required: true,
					regex: '[0-9]*',
					min: 1
				});

				$input.val('0');
			}

			$input.on('blur', function () { $(this).valid(); });
		};

		self.setupCancellationOneForAll = function() {
			if (self.$bookingWidget.find('#NisCancellationAllForOne').prop('checked')) {
				var $cancellationPerPersonContainer = self.$bookingWidget.find('#cancellation-per-person-price');
				$cancellationPerPersonContainer.addClass('hide');
				updatePriceAmountPerPerson();
			}
		};

		self.availableTags = [];
		self.initTagIt = function (selector, countries, available) {
			var $countryContainer = $(selector).parents('.destination');
			$(selector).tagit({
				availableTags: (countries != undefined ? countries : []),
				autocomplete: {
					delay: 0,
					minLength: 2,
					autoFocus: true
				},
				allowSpaces: true,
				allowDuplicates: false,
				allowNewTags: false,
				triggerKeys: ['enter', 'comma', 'tab'],
				beforeTagAdded: function (event, ui) {
					// only op to 8 countries may be selected
					if ($.inArray(ui.tagLabel, countries) === -1 || $countryContainer.find('.tagit-choice').length >= 8) {
						$('.ui-autocomplete-input').val('');
						return false;
					}
				},
				afterTagAdded: function (event, ui) {
					var tag = $.grep(available, function (e) { return e.label == ui.tagLabel; })[0],
						html = self.$countryTemplate.html().replace(/%%value%%/g, tag.iso);

					if ($countryContainer.find('input[name="Countries"][value="' + tag.iso + '"]').length === 0) {
						$countryContainer.append($(html));
					}
					self.common.forms.ervTagit.tagitAfterAddedValidation($(event.target).parent());

					$(this)[0].dispatchEvent(self.common.forms.inputEvent);

					$(this).parent().find('.tagit-choice:last .tagit-label').attr('data-uw-ignore-s17', 'true');

					if (typeof (self.common.framework.cookies.get(window.ERV.ConfigurationSettings.CookieStrings.GTranslate)) !== 'undefined') {
						$('body').find('.tagit .tagit-choice').addClass('notranslate');
					}
				},
				afterTagRemoved: function (event, ui) {
					var country = $.grep(available, function (e) { return e.label === ui.tagLabel;})[0];

					if (typeof (country) != 'undefined') {
						$countryContainer.find("input[value='" + country.iso + "']").remove();
					} else {
						$countryContainer.find("input[data-taglabel='" + ui.tagLabel + "']").remove();
					}

					self.common.forms.ervTagit.tagitAfterRemovedValidation($(event.target).parent());
				}
			});
		};

		self.changeManuallyFileView = function ($typeInput) {
			var $parentInsuranceFields = $typeInput.parents('.insurance-fields'),
				$currentManuallyViews = $parentInsuranceFields.find('[data-view="manually"]'),
				$currentFileUploadViews = $parentInsuranceFields.find('[data-view="fileupload"]');

			if ($typeInput.val() === 'manually') {
				$currentManuallyViews.removeClass('hide');
				$currentFileUploadViews.addClass('hide');

				self.resetFileUpload(true);
				self.setupRulesForManually($parentInsuranceFields);
			} else {
				$currentManuallyViews.addClass('hide');
				$currentFileUploadViews.removeClass('hide');

				self.setupRulesForFileUpload($parentInsuranceFields);
			}
		}

		self.initEventhandlers = function () {
			$(document).on('ervBookingWidgetPeopleCount', function(e) {
				var selector = '.is-priceperson',
					templateSelector = '[data-js="price-per-person"]',
					$categoryForm = e.currentCategoryForm,
					$valueContainer = $categoryForm.find(templateSelector);

				for (var i = 1; i < e.peoplecount; i++) {
					self.addPeopleFields($valueContainer, self.$personPriceTemplate, selector, i);
				}
			});

			self.$categoryForms.on('change', '[name^="uploadtype"]', function() {
				var $typeInput = $(this);

				self.changeManuallyFileView($typeInput);
			});

			var $fileUploads = self.$categoryForms.find('.file-upload');
			if ($fileUploads.length) {
				require(['fileuploadhelper'], function (FileUploadHelper) {
					$fileUploads.each(function() {
						var fileUploadHelper = new FileUploadHelper();
						fileUploadHelper.initCheckFile($(this));
					});
				});
			}

			self.initAmountOfPeopleControl('.add-person', true);
			self.initAmountOfPeopleControl('.remove-person', false);

			self.$categoryForms.on('blur', '[data-js="age-of-people"] input', function() {
				self.bookingRules.isFamily($(this).parents('.insurance-fields'));
			});

			self.$categoryForms.on('keyup', '#TechnicalEquipmentPrice', function () {
				self.bookingRules.isExtendedCarTechnicalEquipment($(this).parents('.insurance-fields'));
			});

			self.$bookingWidget.find('#Input_DailyTravelPersonCount').on('blur', function () {
				self.bookingRules.travelingPeopleNotHigherThanTotalPeople($(this));
			});

            var eventName = self.useWebComponents ? 'ergoChange' : 'change';

            self.$bookingWidget.find('#productcategories').on(eventName, function () {
				self.updateCategoryForm($(this), true);
			});

			self.$bookingWidget.find('[for="NisCancellationAllForOne"]').on('click', function () {
				var $categoryForm = $(this).parents('.insurance-fields'),
					isAllForOne = !$categoryForm.find('#NisCancellationAllForOne').prop('checked');

				self.bookingRules.isNisCancellation($categoryForm, isAllForOne);

                if (isAllForOne) {
					updateTotalPriceAmountPerPerson();
				}

				updatePriceAmountPerPerson(self.$NordicCancellationTotalInput.val());
			});
			
			self.$bookingWidget.find('#Input_HasDailyTravel').on('change', function () {
				var $categoryForm = $(this).parents('.insurance-fields');
				self.bookingRules.hasDailyTravel($categoryForm);
			});
			
			self.$NordicCancellationTotalInput.on('blur', function () {
				updatePriceAmountPerPerson($(this).val());
			});

			self.$NordicCancellationTotalInput.on('keyup', function () {
				updatePriceAmountPerPerson($(this).val());
			});

			self.$bookingWidget.on('change', '[data-js="addon-trigger"]',function () {
				var $trigger = $(this);

				if($trigger.prop('checked')) {
					$trigger.val($trigger.data('addonid'));
				} else {
					$trigger.val('');
				}
			});

			self.$bookingWidgetButton.on('click', function (e) {

				e.preventDefault();
				e.stopPropagation();

				self.setupCancellationOneForAll();

				var $currentForm = self.$categoryForms.find('.insurance-fields:not(.hide)');

				self.common.forms.clearErrors(self.$bookingWidget);

				//bookingproductselectpage validation fix
				var $fakeFileUpload = $currentForm.find('[data-js="trigger-select-file"]');
				if (self.$bookingWidget.find('input[type="text"][data-js="trigger-select-file"]:visible').length && self.$fileUploadNameInput.val() === '') {
					$fakeFileUpload.addClass('input-validation-error');
					return;
				}

				if (!self.$bookingWidget.valid()) {
					self.$ervBody.find('.tagit-hidden-field[data-val="true"]').each(function () {
						if (!$(this).valid()) {
							$(this).parent().find('.tagit.ui-widget').addClass('input-validation-error');
						}
					});

					if (!self.$fileUploadNameInput.valid()) {
						$fakeFileUpload.addClass('input-validation-error');
					}

					return;
				}

				var isWide = self.$bookingWidget.hasClass('wide'),
					$bookingWidgetContent = self.$bookingWidget.find('.booking-content'),
					$resultSection = self.$ervBody.find('#main-content #product-result .page-width'),
					hasResult = $resultSection.length;

				if (isWide) {
					self.common.forms.activateLoading(self.$bookingWidget, false);
				} else {
					self.common.forms.activateLoading($bookingWidgetContent, false);
				}

				if (hasResult) {
					self.common.forms.activateLoadingHorizontal($resultSection.first());
				}

				if (self.$ervBody.find('.traveldays').length) {
					self.bookingRules.businessTravelDaysRule($currentForm);
				}

				//to handle enter submit
				setTimeout(function () {
					if (self.$bookingWidget.find('.input-validation-error:visible').length === 0) {
						if ($currentForm.data('action') != undefined) {
							$(this).attr('action', $currentForm.data('action'));
						}
						self.$bookingWidget.submit();
					} else {
						if (isWide) {
							self.common.forms.deactivateLoading(self.$bookingWidget);
						} else {
							self.common.forms.deactivateLoading($bookingWidgetContent);
						}

						if (hasResult) {
							self.common.forms.deactivateLoadingHorizontal($resultSection);
						}
					}
				}, 200);
			});

			self.fileUploadEventHandlers();
		}

		self.initAmountOfPeopleControl = function (selector, addPerson) {
			self.$categoryForms.on('click', selector, function () {
				var $trigger = $(this);
				if ($trigger.parents('.insurance-fields').data('js') === 'niscancellation') {
					updateAmountOfPeoplePerson($trigger, addPerson, '.is-priceperson', '[data-js="price-per-person"]', self.$personPriceTemplate);
					return;
				}

				updateAmountOfPeoplePerson($trigger, addPerson, '.is-age', '[data-js="age-of-people"]', self.$ageTemplate);
				self.bookingRules.isFamily($trigger.parents('.insurance-fields'));
			});

			self.$categoryForms.on('keydown', selector, function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					$(this).trigger('click');
				}
			});
		}

		self.initAmountOfPeopleControlSimple = function (selector, addPerson, $container) {
			$container.on('click', selector, function () {
				var $trigger = $(this);
				updateAmountOfPeoplePerson($trigger, addPerson, '.is-age', '[data-js="age-of-people"]', self.$ageTemplate, '#' + $container.attr('id'));
				$(document).trigger('change-people');
			});
		}

		self.ervPersonFileCheckedReset = function () {
			var $amountOfPeopleRemove = self.$bookingWidget.find('.remove-person');

			$amountOfPeopleRemove.each(function () {
				var $removeInput = $(this);

				while ($removeInput.parent().find('[data-js="person-count"]').val() > 1) {
					$removeInput.trigger('click');
				}

				self.$bookingWidget.find('.is-age input, .is-priceperson input').val('');
			});
		}

		self.fileUploadEventHandlers = function () {

			$('body').on('ervPersonFileCheckedAndApproved', function (e) {

				if (e.persons != undefined && e.persons.length > 0) {
					var $currentCategoryForm = $(e.currentCategoryForm),
						$amountOfPeopleAdd = $currentCategoryForm.find('.is-amount-of-people .add-person'),
						$ageInputsContainer = $currentCategoryForm.find('[data-js="age-of-people"]'),
						$amountInputsContainer = $currentCategoryForm.find('[data-js="price-per-person"]'),
						hasAgeInputs = $ageInputsContainer.length,
						hasAmountInputs = $amountInputsContainer.length;

					self.ervPersonFileCheckedReset();

					for (var i = 0; i < e.persons.length; i++) {
						if (i > 0) {
							$amountOfPeopleAdd.trigger('click');
						}

						var $input;
						if (hasAgeInputs && e.persons[i].Age != null) {
							$input = $currentCategoryForm.find('input[name="Ages[' + i + ']"]');
							$input.val(e.persons[i].Age);
							$input.blur();
						}

						if (hasAmountInputs && e.persons[i].CoverSum != null) {
							$input = $currentCategoryForm.find('input[name="PersonPrices[' + i + ']"]');
							$input.val(e.persons[i].CoverSum);
							$input.blur();
						}
					}
				}
			});

			$('body').on('ervPersonFileCheckedRemoved', function () {
				self.resetFileUpload(true);
            });
		}

		self.clearFileUpload = function () {
			self.$fileUploadNameInput.removeAttr('data-val');
			self.$fileUploadNameInput.val(null);
			self.$fileUploadNameInput.rules('remove');
			self.common.forms.clearErrors(self.$bookingWidget);
		}

		self.resetFileUpload = function (forced) {
			if (self.$fileUploadNameInput.val() != '') {
				if (forced === true) {
					self.ervPersonFileCheckedReset();
				}
				self.$bookingWidget.find('.uploaded-files li .delete-file').trigger('click');
			}
			self.clearFileUpload();
		}

		self.setupRulesForFileUpload = function ($form) {
			self.bookingRules.isFamily($form);
			self.bookingRules.isNisCancellation($form);

			self.$fileUploadNameInput.attr('data-val', true);

			$form.find('[name^="Ages["], [name^="PersonPrices["]').rules('remove');

			self.$fileUploadNameInput.rules('add',
			{
				required: true
			});
		}

		self.setupRulesForManually = function ($form) {
			self.bookingRules.isFamily($form);
			self.bookingRules.isNisCancellation($form);

            const $agesFields = $form.find('[name^="Ages["]');
            if ($agesFields.length) {
                $agesFields.rules('add',
                    {
                        required: true,
                        regex: '[0-9]*'
                    });
            }


            const $personPricesFields = $form.find('[name^="PersonPrices["]');

            if ($personPricesFields.length) {
                $personPricesFields.rules('add',
                    {
                        required: true,
                        regex: '[0-9]*',
                        min: 1
                    });
            }
		}

		self.updateCategoryForm = function ($select, removeValidation) {
            var selectedOptionSelector = self.useWebComponents ? 'ergo-select-option:selected' : 'option:selected';
			var selected = $select.find(selectedOptionSelector),
				displayGroup = selected.data('displaygroups'),
				buttonname = selected.data('buttonname'),
				hasFileUpload = selected.data('hasfileupload'),
				hidePeople = selected.data('hidepeople'),
				maxItems = selected.data('fileuploadmaxitems'),
				categoryId = Number(selected.val());
            self.$categoryForms.find('.insurance-fields').addClass('hide');
			self.$bookingWidgetButton.text(buttonname);
			self.$bookingWidgetButton.attr('data-cleantext',buttonname);

			self.common.forms.disableFormElementsInContainer(self.$categoryForms, true, removeValidation);

			if (removeValidation) {
				self.$ervBody.find('.validation-summary-errors').remove();
				self.$ervBody.find('.input-validation-error').removeClass('.input-validation-error');
				self.$ervBody.find('.custom-validation-message').addClass('hide');
			}

			if(!displayGroup) {
				return;
			}

			var $form = self.$categoryForms.find('[data-js="' + displayGroup + '"]');
            $form.removeClass('hide');

			self.common.forms.disableFormElementsInContainer($form, false, removeValidation);

			self.bookingRules.isNisCancellation($form);
			self.bookingRules.isFamily($form);
			self.bookingRules.hasDailyTravel($form);
			self.bookingRules.isExtendedCarTechnicalEquipment($form);
			self.setupAddonElements($form);

			if (typeof (selected.data('product')) != 'undefined') {
				self.$bookingWidget.find('#ProductId').val(selected.data('product'));
			}

			self.$bookingWidget.find('#SelectedProductCategoryTag').val(displayGroup);

			var checkIfFieldsEmpty = function () {
				var foundOneEmpty = false;

				$form.find('input[type=text], input[data-inputtype=text]').each(function () {
					var $input = $(this);
					if ($input.attr('id') != undefined && $input.val() === '') {
						foundOneEmpty = true;
					}
				});

				return foundOneEmpty;
			}

			if (self.$ervBody.find('.bookingselectproductpage').length && (self.$bookingWidget.find('.input-validation-error').length > 0 || checkIfFieldsEmpty())) {
				self.$bookingWidget.addClass('is-expanded');
			}

			if (self.$bookingWidget.find('.tagit-hidden-field').hasClass('input-validation-error')) {
				self.$bookingWidget.find('.tagit-hidden-field').parent().find('.tagit.ui-widget').addClass('input-validation-error');
			}

			// Toggle data action
			self.$bookingWidget.attr('action', (typeof ($form.data('action')) !== 'undefined' && $form.data('action') !== '' ? $form.data('action') : self.$bookingWidget.data('base-action')));

            var $manuallyFileContainer = $form.find('.manually-file-container');

			if ($manuallyFileContainer.length === 0) {
				$form.find('[id$="of-people"]').removeClass('hide');
				$form.find('[id$="person-price"]').removeClass('hide');
				self.bookingRules.isNisCancellation($form);

				self.resetFileUpload(true);
				return false;
			}

			var $currentManuallyMoveViews = $form.find('[data-move="manually"]');
			if ($manuallyFileContainer.length === 1 && hasFileUpload) {
				self.setupFileUploadIfExists(categoryId, self, $form, $currentManuallyMoveViews, $manuallyFileContainer, maxItems, hidePeople);
			} else {
				if (self.$bookingWidget.hasClass('wide')) {
					$manuallyFileContainer.after($currentManuallyMoveViews);
				}
				self.resetFileUpload();
				$currentManuallyMoveViews.removeClass('hide');
				$manuallyFileContainer.addClass('hide');
				self.setupRulesForManually($form);
			}
		}

		self.setupAddonElements = function ($form) {
			var $addonFormElements = $form.find('[data-js="isaddon"]');

			$addonFormElements.each(function () {
				var $addonFormElement = $(this),
					$addonInputContainer = $addonFormElement.find('[data-js="addon-container"]'),
					$addonTrigger = $addonFormElement.find('[data-js="addon-trigger"]');

				self.common.forms.disableFormElementsInContainer($addonInputContainer, !$addonTrigger.prop('checked'));
			});
		}

		self.initMainContentFix = function() {
			if (self.$bookingWidget.parents('.editor-body').length > 0) {
				var $form = self.$bookingWidget.find('[data-js="travelinsuranceannual"]');

				$form.find('.destination').addClass('inline-block width-50');
				$form.find('#period').addClass('inline-block width-50');
			}
		}

		self.setupFileUploadIfExists = function(categoryId, self, $form, $currentManuallyMoveViews, $manuallyFileContainer, maxItems, hidePeople) {
			if (categoryId != self.$bookingWidget.attr('data-previouscategoryid')) {
				self.resetFileUpload();
				self.$bookingWidget.attr('data-previouscategoryid', categoryId);
			}
		
			var $maxItemsLabel = $form.find('[data-js="maxitems"]');
			if (self.$bookingWidget.hasClass('wide')) {
				$currentManuallyMoveViews.appendTo($manuallyFileContainer);
			}
		
			if (maxItems === 0) {
				$maxItemsLabel.parent().addClass('hide');
			} else {
				$maxItemsLabel.parent().removeClass('hide');
				$maxItemsLabel.text(maxItems);
			}
		
			$manuallyFileContainer.find('.manually-file-control').toggleClass('hide', hidePeople);
			if (hidePeople) {
				var $radioUpload = $form.find('[name ^= "uploadtype"][value="file"]');
				$manuallyFileContainer.find('[for="' + $radioUpload.attr('id') + '"]').click();
			}
		
			var $label = $manuallyFileContainer.find('label.file-upload');
			if ($label.length && $label.text().trim().length) {
				$manuallyFileContainer.children('label:not(.file-upload)').toggleClass('hide', hidePeople);
				$label.toggleClass('hide', !hidePeople);
			}
		
			$manuallyFileContainer.removeClass('hide');
			var $fileuploadChecked = $form.find('[name ^= "uploadtype"]:checked');
			self.changeManuallyFileView($fileuploadChecked);
		}
	};

	BookingWidget.prototype.init = function () {
		var self = this;
		self.initEventhandlers();

		var available = [];
		var countries = self.$bookingWidget.find('#countries-destinations').find('li').map(function () {
			available.push({ label: $(this).text(), iso: $(this).data('value') });
			return $(this).text();
		}).get();

		self.initTagIt('.countryLabels', countries, available);
		self.initTagIt('.countryLabelsYearly', countries);

		self.updateCategoryForm(self.$bookingWidget.find('#productcategories'), false);

		self.initMainContentFix();

		$('body').trigger('bookingWidgetInitialized');

		if (self.$ervBody.find('.bookingselectproductpage').length > 0 && self.$ervBody.find('form').length > 1) {
			self.$bookingWidget.dirrty({ preventLeaving: false }).on('dirty', function () {
				self.$bookingWidgetButton.text(self.$bookingWidgetButton.data('dirtytext'));
			}).on('clean', function () {
				self.$bookingWidgetButton.text(self.$bookingWidgetButton.data('cleantext'));
			});
		}
	}

	return BookingWidget;
});